import React, { useState, useEffect } from "react";
import "./create-account.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { putwithoutAPI, postWithoutTokenAPI } from "../util/Api";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from 'react-redux';


const Createaccount = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const phone_number = location.state?.phone_number;
    const login = useSelector((state) => state.auth?.auth?.access_token);
    const [showPassword, setShowPassword] = useState(false);
    const [name, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [emailerror, setEmailerror] = useState('');
    const [success, setSuccess] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [passwordErrors, setPasswordErrors] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        specialChar: false
    });

    // List of well-known email providers
    const validEmailProviders = [
        'gmail.com',
        'yahoo.com',
        'hotmail.com',
        'outlook.com',
        'aol.com',
        'protonmail.com',
        'icloud.com',
        'mail.com',
        'zoho.com',
        'yandex.com'
    ];

    // List of valid domain endings
    const validDomainEndings = [
        '.com',
        '.in',
        '.co.in',
        '.org',
        '.net',
        '.edu',
        '.gov',
        '.io',
        '.me',
        '.info'
    ];
    useEffect(() => {
        if (login) {
            navigate('/user'); // or any page you want
        }
    }, [login, navigate]);


    const validateEmail = (email) => {
        // Basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setEmailerror("Invalid email format");
            return false;
        }

        // Extract domain from email
        const domain = email.split('@')[1].toLowerCase();

        // Check if domain ends with valid ending
        const hasValidEnding = validDomainEndings.some(ending => domain.endsWith(ending));
        if (!hasValidEnding) {
            setEmailerror("Email must end with a valid domain (.com, .in, etc.)");
            return false;
        }

        // Check if it's a well-known provider
        const isKnownProvider = validEmailProviders.some(provider => domain === provider);
        if (!isKnownProvider) {
            setEmailerror("Please use a well-known email provider");
            return false;
        }

        setEmailerror("");
        return true;
    };

    // Show verification success toast if coming from OTP verification
    useEffect(() => {
        if (location.state?.verified) {
            toast.success("Phone number verified successfully!", {
                autoClose: 3000
            });
        }
    }, [location.state]);

    // Redirect if no phone number
    // useEffect(() => {
    //     if (!phone_number) {
    //         setTimeout(() => {
    //             toast.error("Please verify your phone number first");

    //             navigate("/creates");
    //         }, 3000);
    //     }
    // }, [phone_number, navigate]);
    useEffect(() => {
        if (!phone_number) {
            toast.error("Please verify your phone number first");

            // Delay navigation
            setTimeout(() => {
                navigate("/creates");
            }, 3000);
        }
    }, [phone_number, navigate]);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const validatePassword = (password) => {
        const errors = {
            length: password.length >= 8,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            number: /\d/.test(password),
            specialChar: /[!@#$%^&*]/.test(password)
        };

        setPasswordErrors(errors);

        return Object.values(errors).every(Boolean);
    };

    // const checkIfExists = async () => {
    //     try {
    //         const response = await postWithoutTokenAPI("/user/check-existence", { email, name });
    //         return response.exists;
    //     } catch (err) {
    //         setError("Error checking username or email");
    //         return false;
    //     }
    // };

    const handleSubmit = async () => {
        setError("");
        setSuccess("");
        setEmailerror("");

        if (!name || !email || !password) {
            setError("All fields are required");
            return;
        }

        if (!validateEmail(email)) {
            return;
        }

        if (!termsAccepted) {
            setError("You must accept the terms and conditions");
            return;
        }

        const isValidPassword = validatePassword(password);
        if (!isValidPassword) {
            setError("Password does not meet requirements");
            return;
        }

        // const exists = await checkIfExists();
        // if (exists) {
        //     setError("Username or email already exists");
        //     return;
        // }
        

        try {
            const response = await putwithoutAPI("/user/update", {
                phone_number: phone_number?.startsWith("+") ? phone_number.slice(1) : phone_number,
                name,
                email,
                password,
                role:"user"
            });

            console.log(response ,'response')
            console.log( {
                phone_number: phone_number?.startsWith("+") ? phone_number.slice(1) : phone_number,
                name,
                email,
                password,
                role:"user"
            } ,'payload')

            if (response?.statusCode === 200 || response?.success) {
                toast.success("Account created successfully!", {
                    autoClose: 3000,
                    onClose: () => navigate("/login")
                });
            } else {
                setError(response?.message || "Failed to create account");
            }
        } catch (err) {
            setError("An error occurred while creating account");
        }
    };

    return (
        <>
            <div className="auth-box-create">
                <ToastContainer />
                <h2 className="auth-title-create">Create Account</h2>

                <div className="auth-field-create">
                    <input
                        className="auth-input"
                        type="text"
                        placeholder="Enter your Username"
                        value={name}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>

                <div className="auth-field">
                    <input
                        className="auth-input"
                        type="email"
                        placeholder="Enter your Email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            validateEmail(e.target.value);
                        }}
                    />
                </div>
                {emailerror && <div className="email-error">{emailerror}</div>}


                <div className="auth-field-create">
                    <div className="auth-password-wrapper-create">
                        <input
                            className="auth-input-create"
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter your Password"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                validatePassword(e.target.value);
                            }}
                        />
                        <span className="auth-eye-icon-create" onClick={togglePasswordVisibility}>
                            {showPassword ? <FiEye /> : <FiEyeOff />}
                        </span>
                    </div>
                    {password && (
                        <div className="password-requirements">
                            <p>Password must contain:</p>
                            <ul>
                                <li className={passwordErrors.length ? "valid" : "invalid"}>
                                    At least 8 characters
                                </li>
                                <li className={passwordErrors.uppercase ? "valid" : "invalid"}>
                                    At least 1 uppercase letter
                                </li>
                                <li className={passwordErrors.lowercase ? "valid" : "invalid"}>
                                    At least 1 lowercase letter
                                </li>
                                <li className={passwordErrors.number ? "valid" : "invalid"}>
                                    At least 1 number
                                </li>
                                <li className={passwordErrors.specialChar ? "valid" : "invalid"}>
                                    At least 1 special character (!@#$%^&*)
                                </li>
                            </ul>
                        </div>
                    )}
                </div>

                <div className="auth-links-create">
                    <div className="auth-remember-section-create">
                        <input
                            type="checkbox"
                            id="remember"
                            checked={termsAccepted}
                            onChange={(e) => setTermsAccepted(e.target.checked)}
                        />
                        <label htmlFor="remember" className="auth-remember-label-create">
                            I accept all<a href='/terms' target="_blank" rel="noopener noreferrer"> Terms & Conditions</a>
                        </label>
                    </div>

                </div>
                {error && <div className="auth-error">{error}</div>}
                {success && <div className="auth-success">{success}</div>}

                <button className="auth-button-create" onClick={handleSubmit}>
                    Create Account
                </button>

                <div className="auth-signup-link-create">
                    <span>Already have an account?</span>
                    <a href="/login">Login</a>
                </div>
            </div>
        </>

    );
};

export default Createaccount;